import { render, staticRenderFns } from "./SimuladorCard.vue?vue&type=template&id=fe987f06&scoped=true"
import script from "./SimuladorCard.vue?vue&type=script&lang=js"
export * from "./SimuladorCard.vue?vue&type=script&lang=js"
import style0 from "./SimuladorCard.vue?vue&type=style&index=0&id=fe987f06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe987f06",
  null
  
)

export default component.exports